import React, { Component } from "react";
import { Row, Col, Card, Container, Alert } from "react-bootstrap";
import ChartOver from "./Chartover";
import Auth from "../Auth";
import Navbar from "./Navbar";
import SignOut from "./SignOut";
import { link, numb2 } from "./link.js";
import axios from "axios";
import Footer from "./footer";
import Loading from "./loading";

class Overall extends Component {
  constructor(props) {
    super(props);
    this.state = { overview: null, loading: true, failed: false };
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.getOverview();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  requestedRoundId = () => {
    const segment = window.location.hash.split("/")[3] || "";
    try {
      return decodeURIComponent(segment);
    } catch (error) {
      return segment;
    }
  };

  getOverview = async () => {
    try {
      const response = await axios.post(
        `${link()}&do=getoverviewsummary&ra=round&ft=rec&id=${encodeURIComponent(this.requestedRoundId())}`,
        {},
        { timeout: 30000 }
      );
      if (this.mounted) this.setState({ overview: response.data, loading: false });
    } catch (error) {
      console.log(error);
      Auth.handleHttpCodes(error, "Overall");
      if (this.mounted) this.setState({ loading: false, failed: true });
    }
  };

  render() {
    const { overview, loading, failed } = this.state;
    const name = localStorage.getItem("name");
    const available = overview && overview.available === true && overview.summary;
    const summary = available ? overview.summary : {};
    const currency = available && overview.round ? overview.round.currency : "";

    return (
      <div>
        <div className="contentdashbord">
          <Navbar />
          <SignOut />
          <Container fluid>
            <div className="welcome d-flex">
              <h6 className="welcomeback">Welcome Back {name}. </h6>{" "}
              {/* <span className="username">  </span> */}
            </div>

            <br />
            {loading && <Loading />}
            {!loading && failed && (
              <Alert variant="danger" role="alert">The overview could not be loaded. Please try again.</Alert>
            )}
            {!loading && !failed && !available && (
              <Alert variant="info">No active round is available.</Alert>
            )}
            {!loading && !failed && available && (
              <>
                <div>
                  <div className="row">
                    <div className="col-md-3 ">
                      <Card className="carddetails ">
                        <Card.Body>
                          <div className="d-block">
                            <p className="descr">Members</p>
                            <p className="numberzero">{summary.numberofMembers}</p>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-md-3">
                      <Card className="carddetails">
                        <Card.Body>
                          <div className="d-block">
                            <p className="descr">Number Of Shares</p>
                            <p className="numberzero">{summary.sharesnumber}</p>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-md-3">
                      <Card className="carddetails">
                        <Card.Body>
                          <div className="d-block">
                            <p className="descr">Total Capital</p>
                            <p className="numberzero">
                              {currency} {numb2(summary.valueofshares)}
                            </p>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-md-3">
                      <Card className="carddetails">
                        <Card.Body>
                          <div className="d-block">
                            <p className="descr"> Monthly Payable Shares</p>
                            <p className="numberzero">{summary.membershipsnumber}</p>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-md-3 ">
                      <Card className="carddetails">
                        <Card.Body>
                          <div className="d-block">
                            <p className="descr"> Monthly contribution</p>
                            <p className="numberzero">
                              {currency} {numb2(summary.termcontributions)}
                            </p>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  <Card className="caerd">
                    <Card.Body>
                      <Row className="cardrow">
                        <Col xs="12" md="7" lg="7">
                          <ChartOver roundId={this.requestedRoundId()} />
                        </Col>
                        <Col xs="12" md="5" lg="5">
                          <div className="peoplecompany">
                            <div className="contcount">
                              <div className="d-block">
                                <p className="descr">Number of Loans</p>
                                <p className="numberzero">{summary.numberofloans}</p>
                              </div>
                              <div className="linehorizontal" />
                            </div>

                            <div className="contcount">
                              <div className="d-block">
                                <p className="descr">Loans Value</p>
                                <p className="numberzero">
                                  {currency} {numb2(summary.loancapitalvalue)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  <br />
                </div>
              </>
            )}
          </Container>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Overall;
